import Exercise from '@/api/exercise';
import ListeningItem from '@/api/listeningItem';
import { isEmpty, isNil } from 'lodash';
import { createI18nFields, createMediaField } from '../common/util';

async function createListeningItem(
  data: { [key: string]: string },
  index: number,
  exercise: Exercise
) {
  const listeningItem = exercise.listening_content.items[index];
  listeningItem.sentence = data[`listen_sentence_${index + 1}`];
  listeningItem.transcription = data[`listen_transcription_${index + 1}`];
  listeningItem.parent_exercise = exercise.id;
  listeningItem.sentence_i18n = createI18nFields(
    data,
    `listening_sentence_${index + 1}_i18n`
  );

  if (!isEmpty(data[`listen_audio_path_${index + 1}`])) {
    const mediaId = await createMediaField(
      data[`listen_audio_path_${index + 1}`],
      exercise.id,
      'exercise',
      'audio'
    );

    listeningItem.audio_path = mediaId;
  }

  if (!isEmpty(data[`listen_image_path_${index + 1}`])) {
    console.log('listen_image_path_', data['listen_image_path_']);
    const imageId = await createMediaField(
      data[`listen_image_path_${index + 1}`],
      exercise.id,
      'exercise',
      'image',
      'image'
    );

    listeningItem.image_path = imageId;
  }

  await listeningItem.save();
  return listeningItem;
}

export async function createListeningContent(
  data: { [key: string]: string },
  exercise: Exercise
) {
  if (isNil(exercise.listening_content)) {
    return;
  }

  const listening = exercise.listening_content;
  listening.correct_index = isEmpty(data['listen_correct_2']) ? 0 : 1;
  listening.parent_exercise = exercise.id;

  if (isEmpty(listening.items)) {
    listening.items = [new ListeningItem(0), new ListeningItem(1)];
  }

  const firstItem = await createListeningItem(data, 0, exercise);
  const secondItem = await createListeningItem(data, 1, exercise);
  listening.items = [firstItem, secondItem];

  await listening.save();
}
